import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";
import { HiMenuAlt1 } from "react-icons/hi";
import { MdClose, MdSearch, MdOutlineAccountCircle } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import { MdOutlineShoppingBag } from "react-icons/md";
import { navBarList } from "../../../constants";
import { logout } from "../../../redux/hejalSlice";
import SearchProducts from "../../SearchProducts/SearchProducts";
import LogoutConfirmationModal from "./LogoutConfirmationModal";

const Header = () => {
  const products = useSelector((state) => state.hejal.cartItems);
  const isLoggedIn = useSelector((state) => state.hejal.isLoggedIn);
  const [showMenu, setShowMenu] = useState(true);
  const [sidenav, setSidenav] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [searchbar, setSearchbar] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  console.log("Header location:", products);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowMenu(false);
        setIsMobile(true);
      } else {
        setShowMenu(true);
        setIsMobile(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".profile-box") && showUserDropdown) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showUserDropdown]);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
    setShowUserDropdown(false);
  };

  const confirmLogout = () => {
    dispatch(logout());
    setShowLogoutModal(false);
    navigate("/signin");
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white shadow-sm">
      <div className="mx-auto px-4 sm:px-6">
        <div className="flex justify-between items-center h-16 md:h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              {/* <img
                src="https://img.freepik.com/free-vector/detailed-click-collect-sign_23-2148794142.jpg?uid=R82625574&ga=GA1.1.1989016628.1740991060&semt=ais_hybrid&w=740"
                alt="bag"
                className="h-14 w-auto object-contain"
              /> */}
              <h1 className="text-2xl font-bold text-black">Luggaelegacy</h1>
            </Link>
          </div>

          {/* Desktop Navigation */}
          {showMenu && (
            <nav className="hidden md:flex items-center space-x-8">
              {navBarList.map(({ _id, title, link }) => (
                <NavLink
                  key={_id}
                  to={link}
                  state={{ data: location.pathname.split("/")[1] }}
                  className={({ isActive }) =>
                    `text-sm font-medium transition-colors duration-200 ${
                      isActive
                        ? "text-[#182134] border-b-2 border-[#182134] pb-0.5"
                        : "text-gray-700 hover:text-[#182134]"
                    }`
                  }
                >
                  {title}
                </NavLink>
              ))}
            </nav>
          )}

          {/* Right side icons */}
          <div className="flex items-center space-x-6">
            {/* Search Button */}
            <button
              className="text-gray-500 hover:text-gray-700 transition-colors md:block hidden"
              aria-label="Search"
              onClick={() => setSearchbar(!searchbar)}
            >
              <MdSearch className="w-6 h-6" />
            </button>

            {/* User Profile */}
            <div className="relative profile-box">
              <button
                onClick={() => setShowUserDropdown(!showUserDropdown)}
                className="flex items-center text-gray-500 hover:text-gray-700 transition-colors md:block hidden"
                aria-label="User account"
              >
                <MdOutlineAccountCircle className="w-6 h-6" />
              </button>

              <AnimatePresence>
                {showUserDropdown && (
                  <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 10 }}
                    transition={{ duration: 0.2 }}
                    className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 ring-1 ring-black ring-opacity-5 focus:outline-none z-50"
                  >
                    {!isLoggedIn ? (
                      <>
                        <Link to="/signin">
                          <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                            Login
                          </div>
                        </Link>
                        <Link to="/signup">
                        <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                          Sign Up
                        </div>
                        </Link>
                      </>
                    ) : (
                      <>
                        <Link to="/profile">
                        <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                          Profile
                        </div>
                        </Link>
                        <Link to="/orders">
                        <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                          Orders
                        </div>
                        </Link>
                        <Link to="/wishlist">
                        <div className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                          Wish List
                        </div>
                        </Link>
                        <button
                          onClick={handleLogoutClick}
                          className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                        >
                          Log Out
                        </button>
                      </>
                    )}
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {/* Shopping Cart */}
            <Link
              to="/cart"
              className="text-gray-500 hover:text-gray-700 transition-colors relative"
              aria-label="Shopping cart"
            >
              <MdOutlineShoppingBag className="w-6 h-6" />
              {products && products.length > 0 && (
                <span className="absolute -top-2 -right-2 flex items-center justify-center w-5 h-5 bg-[#182134] text-white text-xs font-medium rounded-full">
                  {products.length}
                </span>
              )}
            </Link>

            {/* Mobile menu button */}
            <button
              type="button"
              onClick={() => setSidenav(!sidenav)}
              className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-500 hover:text-gray-700 hover:bg-gray-100 focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded={sidenav}
            >
              <span className="sr-only">Open main menu</span>
              {sidenav ? (
                <MdClose className="block h-6 w-6" />
              ) : (
                <HiMenuAlt1 className="block h-6 w-6" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Search overlay */}
      {searchbar && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setSearchbar(false)}
        >
          <div>
            <SearchProducts closeSearch={() => setSearchbar(false)} />
          </div>
        </div>
      )}

      {/* Mobile Navigation Menu */}
      <AnimatePresence>
        {sidenav && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden"
            onClick={(e) => {
              if (e.target === e.currentTarget) setSidenav(false);
            }}
          >
            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", stiffness: 300, damping: 30 }}
              className="relative max-w-xs w-full h-full bg-white shadow-xl overflow-y-auto"
            >
              <div className="px-4 pt-5 pb-2 flex items-center justify-between">
                <div>
                  {/* <img
                    className="h-8 w-auto"
                    src="https://res.cloudinary.com/djnx3xdft/image/upload/v1747378707/hejal_logo_kuw2d1.png"
                    alt="bag"
                  /> */}
                  <h2 className="text-black font-bold text-300">Luggaelegacy</h2>
                </div>
                <button
                  onClick={() => setSidenav(false)}
                  className="rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:bg-gray-100 focus:outline-none"
                >
                  <MdClose className="h-6 w-6" />
                </button>
              </div>
              <div className="px-2 pt-2 pb-3 space-y-1">
                {navBarList.map((item) => (
                  <NavLink
                    key={item._id}
                    to={item.link}
                    state={{ data: location.pathname.split("/")[1] }}
                    onClick={() => setSidenav(false)}
                    className={({ isActive }) =>
                      `block px-3 py-2 rounded-md text-base font-medium ${
                        isActive
                          ? "bg-gray-100 text-[#182134] font-semibold"
                          : "text-gray-700 hover:bg-gray-50"
                      }`
                    }
                  >
                    {item.title}
                  </NavLink>
                ))}
                <Link
                  to="/offers"
                  onClick={() => setSidenav(false)}
                  className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                >
                  Offers
                </Link>

                {isLoggedIn ? (
                  <div className="border-t border-gray-200 pt-4 mt-4">
                    <div className="px-3 text-sm font-medium text-gray-500">
                      Account
                    </div>
                    <Link
                      to="/profile"
                      onClick={() => setSidenav(false)}
                      className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Profile
                    </Link>
                    <Link
                      to="/orders"
                      onClick={() => setSidenav(false)}
                      className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Orders
                    </Link>
                    <Link
                      to="/wishlist"
                      onClick={() => setSidenav(false)}
                      className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Wish List
                    </Link>
                    <button
                      onClick={handleLogoutClick}
                      className="block w-full text-left px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Log Out
                    </button>
                  </div>
                ) : (
                  <div className="border-t border-gray-200 pt-4 mt-4">
                    <Link
                      to="/signin"
                      onClick={() => setSidenav(false)}
                      className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Login
                    </Link>
                    <Link
                      to="/signup"
                      onClick={() => setSidenav(false)}
                      className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-50"
                    >
                      Sign Up
                    </Link>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Logout Confirmation Modal */}
      <LogoutConfirmationModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onConfirm={confirmLogout}
      />
    </header>
  );
};

export default Header;
